var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.46C12.74 13.46 13.34 12.8601 13.34 12.12C13.34 11.38 12.74 10.78 12 10.78C11.2599 10.78 10.66 11.38 10.66 12.12C10.66 12.8601 11.2599 13.46 12 13.46Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.44001C12.74 8.44001 13.34 7.84007 13.34 7.10001C13.34 6.35995 12.74 5.76001 12 5.76001C11.2599 5.76001 10.66 6.35995 10.66 7.10001C10.66 7.84007 11.2599 8.44001 12 8.44001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.47C12.74 18.47 13.34 17.8701 13.34 17.13C13.34 16.39 12.74 15.79 12 15.79C11.2599 15.79 10.66 16.39 10.66 17.13C10.66 17.8701 11.2599 18.47 12 18.47Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDots);
export default __webpack_public_path__ + "static/media/list-dots.a3c523906f5961c7c4049fb7a2c73369.svg";
export { ForwardRef as ReactComponent };